import { render, staticRenderFns } from "./teacher-list.vue?vue&type=template&id=2716af64&scoped=true&"
import script from "./teacher-list.vue?vue&type=script&lang=js&"
export * from "./teacher-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716af64",
  null
  
)

export default component.exports